// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qn-z","play":"rn-z"};